import { CustomerConstant } from '../constants';

const initialState = {};

export default (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case CustomerConstant.SET_CUSTOMERS:
      return { ...state, list: payload };
    default:
      return state;
  }
};
